/*jshint esversion: 6 */
// import store from '@/store/index';
import ViewStore from '@/store/modules/View.store.js';

function Template(payload) {
  let route = {
    path: payload.wallet?
      ':selected_column/trains/:train_id/taktareas/:taktarea_id/twaggons/:twaggon_id/workpackages/:tworkpackage_id'
      :
      (
        payload.location.includes('TaktPlanBacklog')?
        'groups/:wbgroup_id/lines/:wbline_id/workpackages/:wbworkpackage_id'
        :
        'workpackages/:tworkpackage_id'
      ),
    name: `${payload.location}WorkPackageInfo`,
    component: () => import(
      
      `@/views/Project/WorkPackageRework/WorkPackageInfo${ViewStore.getters['getUseOnSite']() ? 'OnSite' : ''}.view.vue`
    ),
    meta: {
      requiresAuth: true
    },
    props: {
      location: payload.location,
      prefix: payload.prefix,
      backlog: payload.backlog,
    }
  };
  if (payload && payload.children) {
    route.children = payload.children;
  }
  return route;
}
export default Template;
